import actions from './actions'

const initialState = {
  loading: false,
  result: { items: [] },
}

export default function activityLogsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return { ...state, loading: true }

    case actions.ACTIVITYLOGS_RECEIVED:
      return { ...state, loading: false, result: action.result }

    default:
      return state
  }
}
